// services/support/entrepriseService.ts
import axios from "axios";
import { Entreprise, EntrepriseStats } from "../types/features/Entreprise";
import { PaginatedResponse } from "../types/core/PaginatedResponse";
import { MAIN_API_URL } from "../config/api";

export const entrepriseService = {
  // Liste paginée des entreprises
  async getEntreprises(token: string, page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Entreprise>> {
    const response = await axios.get<PaginatedResponse<Entreprise>>(`${MAIN_API_URL}/entreprises`, {
      params: { page, per_page: perPage },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  async getEntrepriseById(token: string, id: string): Promise<Entreprise | null> {
    const response = await axios.get<Entreprise>(`${MAIN_API_URL}/entreprises/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

   async getPublicEntrepriseById( id: string): Promise<Entreprise | null> {
    const response = await axios.get<Entreprise>(`${MAIN_API_URL}/entreprises/public/${id}`);
    return response.data;
  },
  

  // Récupérer l'entreprise de l'utilisateur connecté
  async getMyEntreprise(token: string): Promise<Entreprise | null> {
    const response = await axios.get<Entreprise>(`${MAIN_API_URL}/entreprises/my`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // Créer une entreprise (admin seulement)
  async createEntreprise(token: string, data: Omit<Entreprise, "id" | "created_at" | "updated_at">): Promise<Entreprise> {
    const response = await axios.post<Entreprise>(`${MAIN_API_URL}/entreprises`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // Mettre à jour une entreprise
  async updateEntreprise(token: string, id: string, data: Partial<Entreprise>): Promise<Entreprise> {
    const response = await axios.put<Entreprise>(`${MAIN_API_URL}/entreprises/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // Supprimer une entreprise (admin seulement)
  async deleteEntreprise(token: string, id: string): Promise<void> {
    await axios.delete(`${MAIN_API_URL}/entreprises/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  // Récupérer les agents d'une entreprise
  async getEntrepriseAgents(token: string, id: string, page: number = 1, perPage: number = 20): Promise<PaginatedResponse<any>> {
    const response = await axios.get<PaginatedResponse<any>>(`${MAIN_API_URL}/entreprises/${id}/agents`, {
      params: { page, per_page: perPage },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // Statistiques de l'entreprise
  async getEntrepriseStats(token: string, id: string): Promise<EntrepriseStats> {
    const response = await axios.get<EntrepriseStats>(`${MAIN_API_URL}/entreprises/${id}/stats`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};